import axiosInstance from './axios';

export interface ActivationCode {
    id: string;
    code: string;
    companyId: string;
    maxDevices: number;
    usedDevices: number;
    expiresAt?: string;
    status: 'ACTIVE' | 'EXHAUSTED' | 'EXPIRED' | 'REVOKED';
    createdAt: string;
}

export interface ActivationResponse {
    success: boolean;
    message: string;
    activationToken?: string;
    company?: any;
}

/**
 * Validar un código de activación para el dispositivo actual
 */
export const validateActivationCode = async (code: string, deviceId: string, deviceName: string): Promise<ActivationResponse> => {
    const response = await axiosInstance.post<ActivationResponse>('/activation/validate', {
        code,
        deviceId,
        name: deviceName
    });
    return response.data;
};

/**
 * Verificar el estado de la activación actual
 */
export const checkActivationStatus = async (): Promise<{ active: boolean; device?: any }> => {
    const response = await axiosInstance.get<{ active: boolean; device?: any }>('/activation/status');
    return response.data;
};

/**
 * Obtener códigos de activación (Super Admin)
 */
export const getActivationCodes = async (companyId?: string): Promise<ActivationCode[]> => {
    const response = await axiosInstance.get<ActivationCode[]>('/activation/codes', {
        params: { companyId }
    });
    return response.data;
};

/**
 * Actualizar configuración de un código (Super Admin)
 */
export const updateActivationCode = async (id: string, data: { maxDevices: number }): Promise<ActivationCode> => {
    const response = await axiosInstance.post<ActivationCode>(`/activation/codes/${id}`, data);
    return response.data;
};

export default {
    validateActivationCode,
    checkActivationStatus,
    getActivationCodes,
    updateActivationCode
};
